var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpanish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_spanish_flag)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    fill: "#C60B1E"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 3.75,
    width: 21,
    height: 7.5,
    fill: "#FFC400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_spanish_flag"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanish);
export default __webpack_public_path__ + "static/media/spanish.f7d7e2acccf7e53cd649b5be15edd4eb.svg";
export { ForwardRef as ReactComponent };